import React from 'react';
import { Paper, Box, TextField, Grid } from '@material-ui/core';
import { fmtThousand } from '@/utils/comUtil';
import OrderCardStyled from './orderCardStyles';

export default ({ data, list, formatMessage }) => {
  return (
    <OrderCardStyled>
      <Paper sx={{ padding: '16px 24px 31px', borderRadius: '4px' }}>
        <Box className="detail-title">
          {formatMessage({ id: 'order.order.detail.n02.lbl01' })}
        </Box>
        <Grid container spacing={7} sx={{ gap: '36px 0', marginTop: 0 }}>
          {list.map((item, index) => {
            let d = '';
            if (data && data[item.id]) {
              if (item.id === 'amountTotal' || item.id === 'amountPaid') {
                d = fmtThousand(data[item.id]);
              } else {
                d = data[item.id];
              }
            }
            return (
              <Grid
                item
                xs={3}
                key={`vip${index}`}
                sx={{ paddingTop: '0!important' }}
              >
                <Box display="flex" flexDirection="column">
                  <TextField
                    id="filled-read-only-input"
                    label={
                      <Box className="text-detail-label">{item.label}</Box>
                    }
                    value={d}
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="standard"
                    className="text-detail-info"
                  />
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Paper>
    </OrderCardStyled>
  );
};
